import { COSMOS_KEY, type CosmosConfig } from "../entities/cosmos"

const BUCKET_URL = "https://storage.googleapis.com/educabot-aec-cdn-1/tuni/cosmos"

// TO DO: Delete. This will coming from the backend in the future.
export const cosmosConfig: Record<COSMOS_KEY, CosmosConfig> = {
  [COSMOS_KEY.DEFAULT]: {
    colors: {
      primary: {
        50: "#FFF7ED",
        100: "#FFEDD5",
        200: "#FED7AA",
        300: "#FDBA74",
        400: "#FB923C",
        500: "#F97316",
        600: "#EA580C",
        700: "#C2410C",
        800: "#8C3507",
        900: "#693009",
      },
      alternatives: [
        "#3B82F6",
        "#8B5CF6",
        "#FACC15",
        "#F43F5E",
        "#84CC16",
        "#6366F1",
        "#EC4899",
        "#22D3EE",
      ],
    },
    meta: {
      title: "Tich AI",
      logoUrl: `${BUCKET_URL}/default/logo.png`,
      faviconUrl: `${BUCKET_URL}/default/favicon.ico`,
    },
    onboarding: {
      videoUrl: `${BUCKET_URL}/default/onboarding.mp4`,
    },
  },
  [COSMOS_KEY.MENDOZA]: {
    colors: {
      primary: {
        50: "#e6e7f5",
        100: "#b0b5e1",
        200: "#8a91d3",
        300: "#545ebf",
        400: "#333fb2",
        500: "#000f9f",
        600: "#000e91",
        700: "#000b71",
        800: "#000857",
        900: "#000643",
      },
      alternatives: [
        "#3cb4e5",
        "#F76E2A",
        "#00BFA5",
        "#8E24AA",
        "#F6CF00",
        "#c8a977",
        "#009688",
        "#2962FF",
      ],
    },
    meta: {
      title: "Tich AI",
      logoUrl: `${BUCKET_URL}/mendoza/logo.png`,
      faviconUrl: `${BUCKET_URL}/mendoza/favicon.ico`,
    },
    onboarding: {
      videoUrl: `${BUCKET_URL}/mendoza/onboarding.mp4`,
    },
  },
  [COSMOS_KEY.SIGLO21]: {
    colors: {
      primary: {
        50: "#e6f0ef",
        100: "#b0d1cc",
        200: "#8abbb4",
        300: "#549d91",
        400: "#33897c",
        500: "#006c5b",
        600: "#006253",
        700: "#004d41",
        800: "#003b32",
        900: "#002d26",
      },
      alternatives: [
        "#F76E2A",
        "#C026D3",
        "#F0C505",
        "#E7204E",
        "#651366",
        "#C01F69",
        "#2F5C9C",
        "#FF3D00",
      ],
    },
    meta: {
      title: "Tich AI",
      logoUrl: `${BUCKET_URL}/siglo21/logo.png`,
      faviconUrl: `${BUCKET_URL}/siglo21/favicon.ico`,
    },
    onboarding: {
      videoUrl: `${BUCKET_URL}/siglo21/onboarding.mp4`,
    },
  },
}
